import React, { createContext, useEffect, useState } from "react";

import { InteractionType, IPublicClientApplication, AccountInfo } from "@azure/msal-browser";

import { useMsal, useMsalAuthentication } from "@azure/msal-react";

import { loginRequest } from "./authConfig";
import { isMobile } from "react-device-detect";

export interface IAuthProvider {
  activeAccount: AccountInfo | null;
  instance: IPublicClientApplication;
  logIn: () => void;
  logOut: () => void;
}

const AuthContext = createContext({} as IAuthProvider);

interface AuthProps {
  children?: React.ReactNode;
}
const AuthProvider: React.FunctionComponent<AuthProps> = ({ children }) => {
  const [activeAccount, setActiveAccount] = useState<null | AccountInfo>(null);
  const { result } = useMsalAuthentication(InteractionType.Silent, loginRequest);
  const { instance } = useMsal();

  useEffect(() => {
    if (result) {
      setActiveAccount(result.account);
    }
  }, [result]);

  const logOut = () => {
    instance.logoutPopup({ account: activeAccount }).catch((e) => {
      console.error(e);
    });
  };

  const logIn = () => {
    isMobile ? redirectWorkflow() : popupWorkflow();
  };

  const popupWorkflow = () => {
    instance
      .loginPopup(loginRequest)
      .then((response) => setActiveAccount(response.account))
      .catch((e: any) => {
        console.error(e);
      });
  };

  const redirectWorkflow = () => {
    instance.handleRedirectPromise().then((response) => {
      if (response !== null) {
        setActiveAccount(response.account);
        // Display signed-in user content, call API, etc.
      } else {
        // In case multiple accounts exist, you can select
        const currentAccounts = instance.getAllAccounts();

        if (currentAccounts.length === 0) {
          // no accounts signed-in, attempt to sign a user in
          instance.loginRedirect(loginRequest);
        } else if (currentAccounts.length > 1) {
          // Add choose account code here
        } else if (currentAccounts.length === 1) {
          setActiveAccount(currentAccounts[0]);
        }
      }
    });
  };

  const authContextValue = {
    instance,
    activeAccount,
    logIn,
    logOut,
  };
  return <AuthContext.Provider value={authContextValue}>{children}</AuthContext.Provider>;
};

const useAuth = () => {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within a AuthProvider");
  }
  return context;
};

export { AuthProvider, useAuth };
